import { render, staticRenderFns } from "./DashboardBarChart.vue?vue&type=template&id=d24b89f6&scoped=true&"
import script from "./DashboardBarChart.vue?vue&type=script&lang=js&"
export * from "./DashboardBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24b89f6",
  null
  
)

export default component.exports